/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ accepted: NonNullable<unknown> }} Interview_Slots_Capacity_ErrorInputs */

const en_interview_slots_capacity_error = /** @type {(inputs: Interview_Slots_Capacity_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There are ${i?.accepted} accepted applications without an appointment – at least ${i?.accepted} free appointments must remain.`)
};

const de_interview_slots_capacity_error = /** @type {(inputs: Interview_Slots_Capacity_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Es gibt ${i?.accepted} angenommene Bewerbungen ohne Termin – es müssen mindestens ${i?.accepted} freie Termine bleiben.`)
};

/**
* | output |
* | --- |
* | "There are {accepted} accepted applications without an appointment – at least {accepted} free appointments must remain." |
*
* @param {Interview_Slots_Capacity_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const interview_slots_capacity_error = /** @type {((inputs: Interview_Slots_Capacity_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Slots_Capacity_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_slots_capacity_error(inputs)
	return en_interview_slots_capacity_error(inputs)
});